import { themeColorsDark } from '@juvare/common-web-ui/JuvareTheme/colors/themeColorsDark';
import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

export interface RequiredInformationDialogHeaderProps {
    onClose: () => void;
    accountId: string;
}

export const RequiredInformationDialogHeader: React.FC<RequiredInformationDialogHeaderProps> = ({ onClose, accountId }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleCancel = () => {
        navigate(`/accounts/${accountId}?tab=backgroundcheck`);
        onClose();
    };

    return (
        <Box
            sx={{
                alignItems: 'center',
                backgroundColor: themeColorsDark.background,
                color: themeColorsDark.text.main,
                display: 'flex',
                justifyContent: 'space-between',
                px: 5,
                py: 2,
            }}
        >
            <Typography variant='h6'>{t('backgroundCheck.labels.requiredInformation')}</Typography>
            <Box sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                <Button variant='text' color='inherit' size='large' sx={{ p: 0 }} data-test='cancel-button' onClick={handleCancel}>
                    {t('common.cancel')}
                </Button>
            </Box>
        </Box>
    );
};
